import { Modal, Input, Button, Typography, notification } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  changeWeldNumber,
  changeWeldNumberWithUid,
} from "../../redux/data360LiveSlog/action";

const { Text } = Typography;

const EditWeldNumberModal = ({
  open,
  weldNumber,
  newWeldNumber,
  setNewWeldNumber,
  onCancel,
  onConfirm,
  projectId,
  weldUid,
  useUidApi = false,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = () => {
    if (!newWeldNumber.trim()) {
      notification.error({
        message: "Error",
        description: "Please enter a new weld number",
      });
      return;
    }

    if (!projectId) {
      notification.error({
        message: "Error",
        description: "Project ID is required",
      });
      return;
    }

    setIsLoading(true);

    const actionPayload = {
      project_id: projectId,
      old_weld_number: weldNumber,
      new_weld_number: newWeldNumber.trim(),
    };

    if (useUidApi && weldUid) {
      actionPayload.weld_uid = weldUid;
      dispatch(changeWeldNumberWithUid(actionPayload));
    } else {
      dispatch(changeWeldNumber(actionPayload));
    }

    setTimeout(() => {
      setIsLoading(false);
      onConfirm();
    }, 1000);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      title="Confirm Weld Number Update"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} disabled={isLoading}>
          Cancel
        </Button>,
        <Button
          key="confirm"
          type="primary"
          danger
          onClick={handleConfirm}
          loading={isLoading}
        >
          Confirm
        </Button>,
      ]}
      width={500}
      centered
    >
      <div style={{ marginBottom: 16 }}>
        <Text>
          Do you want to modify the weld number <strong>{weldNumber}</strong>?
        </Text>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Text strong style={{ display: "block", marginBottom: 8 }}>
          Enter the new weld number:
        </Text>
        <Input
          placeholder="New Weld Number"
          value={newWeldNumber}
          onChange={(e) => setNewWeldNumber(e.target.value)}
          size="large"
          disabled={isLoading}
        />
      </div>
    </Modal>
  );
};

export default EditWeldNumberModal;
